import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Exam Practice',
    ImagePath: '/assets/images/landing/online-workbook.png',
    DestinationPage: 'exam-practice-questions',
  },
  {
    Text: 'Video Solutions',
    ImagePath: '/assets/images/landing/exam-skills-videos.png',
    DestinationPage: 'worked-answer-videos',
  },
  {
    Text: 'Practice Papers',
    ImagePath: '/assets/images/landing/practice-papers.png',
    DestinationPage: 'practice-papers',
  },
  {
    Text: 'Extras',
    ImagePath: '/assets/images/landing/pdfs.png',
    DestinationPage: 'extras',
  }
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.ExamPracticeQuestions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Exam Practice Questions',
    ButtonURL: 'exam-practice-questions',

    MixedOnlineTests: [
      {
        // TODO: verify URL
        MixedOnlineTestUrl: '_revisionhub_opc/MFQ48/MFQ48_DigitalWorkbook_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Exam Practice Questions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples, then see how it\'s going with your progress tracker.</p>' +
      '<p>Questions marked: <strong>[[variable1]]</strong></p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'All the questions from your book',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.VideoSolutions,
    IsFreeSample: false,
    IconPath: '/assets/images/landing/exam-skills-videos.png',
    Anchor: '',
    ButtonColour: '#FF9335',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    // TODO: verify ButtonURL - valid options for VideoSolutions:
    //   'content-videos'       -> route: products/{code}/content-videos/{subcategory}
    //   'worked-answer-videos' -> route: products/{code}/worked-answer-videos/{subcategory}
    //   'video-solutions'      -> route: products/{code}/video-solutions/{subcategory}
    ButtonURL: 'worked-answer-videos',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Worked answer videos with lots of advice to help you scoop up every last mark.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro: '<p>CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book  -  have a go at the questions first and use these videos if you need a bit of extra help.</p>',
                LeftSections: [
          {
            Header: 'Section One  -  Number',
            Subcategories: [
              { Name: 'Wordy Real-Life Problems', ShortName: '/wordy-real-life-problems', Link: 'https://www.youtube.com/embed/pC-jgMWLe5c?rel=0&modestbranding=1' },
              { Name: 'LCM and HCF', ShortName: '/lcm-and-hcf', Link: 'https://www.youtube.com/embed/ZX4gWSOaoHg?rel=0&modestbranding=1' },
              { Name: 'Fractions', ShortName: '/fractions', Link: 'https://www.youtube.com/embed/uMFOefdUGUw?rel=0&modestbranding=1' },
              { Name: 'Estimating and Error', ShortName: '/estimating-and-error', Link: 'https://www.youtube.com/embed/iAVfNkickec?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Two  -  Algebra',
            Subcategories: [
              { Name: 'Multiplying and Brackets', ShortName: '/multiplying-and-brackets', Link: 'https://www.youtube.com/embed/vZfKQyxNPKg?rel=0&modestbranding=1' },
              { Name: 'Solving Equations', ShortName: '/solving-equations', Link: 'https://www.youtube.com/embed/ekPiQ0oBbos?rel=0&modestbranding=1' },
              { Name: 'Equations from Words and Diagrams', ShortName: '/equations-from-words-and-diagrams', Link: 'https://www.youtube.com/embed/v1wF5w1cuyw?rel=0&modestbranding=1' },
              { Name: 'Sequences', ShortName: '/sequences', Link: 'https://www.youtube.com/embed/G98nm3Ri0BY?rel=0&modestbranding=1' },
              { Name: 'Proof', ShortName: '/proof', Link: 'https://www.youtube.com/embed/hwBZaWYtwdM?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Three  -  Graphs',
            Subcategories: [
              { Name: 'Straight Line Graphs', ShortName: '/straight-line-graphs', Link: 'https://www.youtube.com/embed/ePK3WDGLAvI?rel=0&modestbranding=1' },
              { Name: 'Solving Equations Using Graphs', ShortName: '/solving-equations-using-graphs', Link: 'https://www.youtube.com/embed/Jk4pBzMj2uQ?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Four  -  Ratio, Proportion and Rates of Change',
            Subcategories: [
              { Name: 'Ratios', ShortName: '/ratios', Link: 'https://www.youtube.com/embed/Kip_z7sCCjs?rel=0&modestbranding=1' },
              { Name: 'Inverse Proportion Problems', ShortName: '/inverse-proportion-problems', Link: 'https://www.youtube.com/embed/KQRGc92Pvmg?rel=0&modestbranding=1' },
              { Name: 'Compound Growth and Decay', ShortName: '/compound-growth-and-decay', Link: 'https://www.youtube.com/embed/lIIuxmlz_lQ?rel=0&modestbranding=1' },
              { Name: 'Density and Pressure', ShortName: '/density-and-pressure', Link: 'https://www.youtube.com/embed/f19YCE8nnJs?rel=0&modestbranding=1' },
            ],
          },
        ],
                RightSections: [
          {
            Header: 'Section Five  -  Shapes and Area',
            Subcategories: [
              { Name: 'The Four Transformations', ShortName: '/the-four-transformations', Link: 'https://www.youtube.com/embed/YlE8BLxPSTI?rel=0&modestbranding=1' },
              { Name: 'Perimeter and Area  -  Circles', ShortName: '/perimeter-and-area-circles', Link: 'https://www.youtube.com/embed/HQVgx41f-yI?rel=0&modestbranding=1' },
              { Name: '3D Shapes', ShortName: '/3d-shapes', Link: 'https://www.youtube.com/embed/mc3V1pocTrQ?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Six  -  Angles and Geometry',
            Subcategories: [
              { Name: 'Parallel Lines', ShortName: '/parallel-lines', Link: 'https://www.youtube.com/embed/u5rQpB2E8Lc?rel=0&modestbranding=1' },
              { Name: 'Loci and Construction', ShortName: '/loci-and-construction', Link: 'https://www.youtube.com/embed/HNHCsfTUbug?rel=0&modestbranding=1' },
              { Name: 'Vectors', ShortName: '/vectors', Link: 'https://www.youtube.com/embed/kMgnM0ZBtBs?rel=0&modestbranding=1' },
            ],
          },
          {
            Header: 'Section Seven  -  Probability and Statistics',
            Subcategories: [
              { Name: 'Probability Experiments', ShortName: '/probability-experiments', Link: 'https://www.youtube.com/embed/po_GCJFAJrQ?rel=0&modestbranding=1' },
              { Name: 'Tree Diagrams', ShortName: '/tree-diagrams', Link: 'https://www.youtube.com/embed/BmaYOLUln4I?rel=0&modestbranding=1' },
              { Name: 'Simple Charts and Graphs', ShortName: '/simple-charts-and-graphs', Link: 'https://www.youtube.com/embed/JpAbE83yncQ?rel=0&modestbranding=1' },
              { Name: 'Grouped Frequency Tables', ShortName: '/grouped-frequency-tables', Link: 'https://www.youtube.com/embed/mo8XqtiHvtQ?rel=0&modestbranding=1' },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.PracticePapers,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Practice Papers',
    ButtonURL: 'practice-papers',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Practice Papers',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Mark the Practice Papers in your book, or print extra copies if you want another go.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Full exam practice',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '<p>If you\'ve had a go at the Practice Papers in your book and are looking for the answers, you\'ll find them below. Or if you want another go at the papers in exam conditions, you can also download the practice papers and print out extra copies. Good luck!</p>\n' +
      '\n' +
      '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MFQ48/PDFs/cgp-gcse-maths-foundation-paper-1.pdf"><span style="color:#1494d4;">Foundation Paper 1</span></a></p>\n' +
      '\n' + 
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MFQ48/PDFs/cgp-gcse-maths-foundation-paper-2.pdf"><span style="color:#1494d4;">Foundation Paper 2</span></a></p>\n' +
        '\n' + 
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MFQ48/PDFs/cgp-gcse-maths-foundation-paper-3.pdf"><span style="color:#1494d4;">Foundation Paper 3</span></a></p>\n' +
        '\n' + 
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/MFQ48/PDFs/cgp-gcse-maths-foundation-paper-answers.pdf"><span style="color:#1494d4;">Foundation Paper Answers</span></a></p>\n',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    ButtonURL: 'extras',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Formula sheets and exam tips.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      // TODO: populate ContentMain with intro text and ContentRight with an image if needed
      HeaderText: 'Extra Useful Bits',
      ContentMain: '<div>'+
        '<p>Here\'s a printable formula sheet, plus tips on what to expect in your Maths exams  -  take your pick!</p>' +
        '<strong>' + 
        '<a href="[[cloudfront_url]]/_revisionhub_opc/MFQ48/PDFs/cgp-gcse-maths-foundation-formula-sheet.pdf"><span style="color:#1494d4;">Printable Formula Sheet</span></a><br />' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/MFQ48/PDFs/cgp-gcse-maths-exam-tips-and-tricks.pdf"><span style="color:#1494d4;">Exam Tips and Tricks</span></a><br />' +
        '</strong>' +
        '</div>' ,
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Take a look at our helpful FAQs or find out how to get in touch with us if you need some help.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
      '<h5>What is CGP RevisionHub?</h5>\n' +
      '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Maths Workbooks. Use the Online Workbook, videos and more to make sure you know your stuff for the exams.</p>\n' +
      '<h5>How do I access CGP RevisionHub?</h5>\n' +
      '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
      '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
      '<p>You\'ll notice lots of QR codes scattered throughout your book. Give them a scan and you\'ll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you\'ve learned!</p>\n' +
      '<h5>My CGP RevisionHub isn\'t working  —  what do I do?</h5>\n' +
      '<p>If you can\'t find the answer in these FAQs, it\'s time to contact our friendly Customer Services team. You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
      '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
      '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
      '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
      '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
      '<h5>How do I use the Online Workbook?</h5>\n' +
      '<p>All the questions from your book are available to answer again online and you can filter them by type, e.g. Problem Solving. There’s also a QR code on each page of your book that will take you directly to the questions for that page. You’ll mark some of the questions yourself by looking at the answers, and the rest are marked automatically in CGP RevisionHub  -  wow!</p>\n' +
      '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
      '<p>You can reset your answers in the Online Workbook any time you like! Just click "Reset your answers" at the bottom of the Your Exam Practice menu page.</p>\n' +
      '<h5>Can I share my test results with other people?</h5>\n' +
      '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?</p>\n' +
      '<h5>What happens when I\'ve answered all the questions?</h5>\n' +
      '<p>Ah, one of life\'s greatest questions  —  what next? We\'d recommend that you keep practising right up until your exams.</p>\n' +
      '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
      '<p>Once you activate the code in the front of your book, you\'ll have access for three years. And they\'ll be three whole years of bliss, we promise.</p>\n',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP Revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>There\'s plenty more revision where this came from! Take a look at some of our other revision books.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },}
];